import { AxiosResponse } from "axios";
import { I_SendingPaginationData } from "../../../Models/sendingDataSchema";
import { _axios } from "../../Base_Axios_Config/_axios";
import {
  I_Message,
  I_RecevedAllGroupsFromServer,
} from "../../../Models/interfaces";

export const getEditableGroupsService = async (_data: {
  _data: I_SendingPaginationData;
  userToken: string;
}): Promise<
  AxiosResponse<{
    error: number;
    messages: I_Message[];
    result: I_RecevedAllGroupsFromServer;
  }>
> => {
  return _axios.get(
    `/groups/editable?page=${_data._data.page}&size=${_data._data.size}&search=${_data._data.search}&tenant=${_data._data.tenant}`,
    {
      headers: {
        Authorization: `Bearer ${_data.userToken}`,
      },
    }
  );
};
